// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2RdBY","colCheckbox":"styles_colCheckbox__2dbbP"};